import { render, staticRenderFns } from "./FuneralService.vue?vue&type=template&id=c674bb24&"
import script from "./FuneralService.vue?vue&type=script&lang=js&"
export * from "./FuneralService.vue?vue&type=script&lang=js&"
import style0 from "./FuneralService.vue?vue&type=style&index=0&id=c674bb24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports